module.exports = __webpack_public_path__ + "static/subset-UniNeueThin-64c60bf5e7352e6d81f960880bc28922.woff2";